module.exports = __webpack_public_path__ + "static/media/16UNODC8.f0ed75aa.jpg";